module.exports = __webpack_public_path__ + "static/img/mini-home.9d27b873.svg";